import { Accordion, Button, ButtonsGroup, Card, Grid, InputText } from "#/atoms";
import { FC, memo } from "react";

import { DESKTOP_SPACING } from "@/theme";
import { PhotoCountCardProps } from "./PhotoCount.interface";

const PhotoCountCard: FC<PhotoCountCardProps> = ({
  accordionState = 'open',
  photoCount,
  onUpdatePhotoCount
}) => {
  return (
    <Card>
      <Accordion
        header={<strong>Appropriate number of photos to edit</strong>}
        showArrow
        state={accordionState}
      >
        <Grid columnGap={DESKTOP_SPACING.XL} gridTemplateColumns="repeat(1, 40%)" margin="10px">
        <InputText
            type="number"
            label="The number above is just an estimation, billing will happen for the actual number of images edited"
            value={photoCount.value}
            onChange={photoCount.onChange}
          />
          <ButtonsGroup>
              <Button onClick={() => onUpdatePhotoCount?.(Number(photoCount.value))}>
                  Save
              </Button>
            </ButtonsGroup>
        </Grid>
      </Accordion>
    </Card>
  );
};

export default memo(PhotoCountCard);